// extracted by mini-css-extract-plugin
export var columnItem = "_dg-3";
export var columnItemDraggable = "_dg-5";
export var dragHandle = "_dg-0";
export var dragHandleHovered = "_dg-1";
export var dropdown = "_dg-6";
export var dropdownContent = "_dg-8";
export var dropdownInner = "_dg-7";
export var filterDropdownHeader = "_dg-9";
export var icon = "_dg-2";
export var moveToTopButton = "_dg-4";
export var sectionDivider = "_dg-a";